// extracted by mini-css-extract-plugin
module.exports = {"gifWrapper":"NSImage_gifWrapper__wF2Dh","gif-hidden":"NSImage_gif-hidden__WcVVI","imageWrapper":"NSImage_imageWrapper__T9hZ_"};